(function () {
  if (window.QQVideoReviews && typeof window.QQVideoReviews.init === 'function') {
    window.QQVideoReviews.init();
    return;
  }

  var instagramStates = new WeakMap();

  function initTabs(root) {
    if (root.hasAttribute('data-qq-tabs-initialized')) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-qq-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-qq-panel]'));
    if (!tabs.length || !panels.length) return;

    root.setAttribute('data-qq-tabs-initialized', 'true');
    rememberDeferredMedia(root);
    initInstagramSliders(root);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-qq-tab');
        activateTab(tabs, panels, target);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') return;

        event.preventDefault();
        var currentIndex = tabs.indexOf(tab);
        var nextIndex = currentIndex;
        if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          var direction = event.key === 'ArrowRight' ? 1 : -1;
          nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
        }
        tabs[nextIndex].focus();
        activateTab(tabs, panels, tabs[nextIndex].getAttribute('data-qq-tab'));
      });
    });
  }

  function initInstagramSliders(root) {
    root.querySelectorAll('[data-qq-instagram-panel]').forEach(function (panel) {
      var scroller = panel.querySelector('[data-qq-instagram-scroller]');
      if (!scroller || scroller.hasAttribute('data-qq-instagram-initialized')) return;

      var cards = Array.prototype.slice.call(scroller.querySelectorAll('[data-qq-instagram-card]'));
      if (!cards.length) return;

      scroller.setAttribute('data-qq-instagram-initialized', 'true');
      var state = {
        current: 0,
        inView: false,
        scrollTimer: null
      };
      instagramStates.set(panel, state);
      selectInstagramCard(panel, 0);

      scroller.addEventListener('scroll', function () {
        window.clearTimeout(state.scrollTimer);
        state.scrollTimer = window.setTimeout(function () {
          var nextIndex = getNearestInstagramIndex(scroller, cards);
          if (nextIndex !== state.current) {
            pauseInstagramCard(cards[state.current]);
            selectInstagramCard(panel, nextIndex);
          }
          playInstagramPanel(panel);
        }, 90);
      }, { passive: true });

      cards.forEach(function (card, index) {
        card.addEventListener('click', function () {
          scrollInstagramTo(scroller, card);
          if (state.current !== index) {
            pauseInstagramCard(cards[state.current]);
            selectInstagramCard(panel, index);
          }
          playInstagramPanel(panel);
        });
      });

      var prev = panel.querySelector('[data-qq-instagram-prev]');
      var next = panel.querySelector('[data-qq-instagram-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          moveInstagram(panel, -1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          moveInstagram(panel, 1);
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            state.inView = entry.isIntersecting;
            if (state.inView) {
              playInstagramPanel(panel);
            } else {
              pauseInstagramPanel(panel);
            }
          });
        }, { threshold: 0.35 });
        observer.observe(panel);
      } else {
        state.inView = true;
        playInstagramPanel(panel);
      }
    });
  }

  function initPosters(root) {
    root.querySelectorAll('[data-qq-auto-poster]').forEach(function (image) {
      if (image.hasAttribute('data-qq-poster-initialized')) return;
      image.setAttribute('data-qq-poster-initialized', 'true');

      var provider = image.getAttribute('data-qq-video-provider');
      var url = image.getAttribute('data-qq-video-url') || '';
      var posterUrl = provider === 'instagram' ? getInstagramPosterUrl(url) : getYoutubePosterUrl(url);
      var placeholder = image.parentElement && image.parentElement.querySelector('[data-qq-poster-placeholder]');

      if (!posterUrl) return;

      function showPoster() {
        image.hidden = false;
        if (placeholder) placeholder.hidden = true;
      }

      function showPlaceholder() {
        image.hidden = true;
        if (placeholder) placeholder.hidden = false;
      }

      image.addEventListener('load', showPoster, { once: true });
      image.addEventListener('error', showPlaceholder, { once: true });

      image.src = posterUrl;

      if (image.complete) {
        if (image.naturalWidth > 0) {
          showPoster();
        } else {
          showPlaceholder();
        }
      }
    });
  }

  function getYoutubePosterUrl(url) {
    var id = getYoutubeId(url);
    return id ? 'https://img.youtube.com/vi/' + encodeURIComponent(id) + '/hqdefault.jpg' : '';
  }

  function getYoutubeId(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      var host = parsed.hostname.replace(/^www\./, '');
      if (host === 'youtu.be') {
        return parsed.pathname.split('/').filter(Boolean)[0] || '';
      }
      if (host.indexOf('youtube.com') > -1) {
        if (parsed.searchParams.get('v')) return parsed.searchParams.get('v');
        var parts = parsed.pathname.split('/').filter(Boolean);
        var markerIndex = parts.findIndex(function (part) {
          return part === 'embed' || part === 'shorts' || part === 'live';
        });
        if (markerIndex > -1 && parts[markerIndex + 1]) return parts[markerIndex + 1];
      }
    } catch (error) {
      return '';
    }
    return '';
  }

  function getInstagramPosterUrl(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      var host = parsed.hostname.replace(/^www\./, '');
      if (host.indexOf('instagram.com') === -1) return '';
      var parts = parsed.pathname.split('/').filter(Boolean);
      var markerIndex = parts.findIndex(function (part) {
        return part === 'p' || part === 'reel' || part === 'tv';
      });
      if (markerIndex === -1 || !parts[markerIndex + 1]) return '';
      return 'https://www.instagram.com/' + parts[markerIndex] + '/' + parts[markerIndex + 1] + '/media/?size=l';
    } catch (error) {
      return '';
    }
  }

  function activateTab(tabs, panels, target) {
    tabs.forEach(function (item) {
      var isActive = item.getAttribute('data-qq-tab') === target;
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-qq-panel') === target;
      if (!isActive) {
        pausePanelMedia(panel);
        pauseInstagramPanel(panel);
      }
      panel.hidden = !isActive;
      if (isActive && target === 'instagram') {
        playInstagramPanel(panel);
      }
    });
  }

  function pausePanelMedia(panel) {
    panel.querySelectorAll('video-media').forEach(function (media) {
      if (typeof media.pause === 'function') {
        media.paused = true;
        media.pause();
      }

      media.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });

      resetDeferredMedia(media);
    });
  }

  function rememberDeferredMedia(root) {
    root.querySelectorAll('video-media').forEach(function (media) {
      if (!media.__qqInitialHTML) {
        media.__qqInitialHTML = media.outerHTML;
      }
    });
  }

  function resetDeferredMedia(media) {
    var initialHTML = media.__qqInitialHTML;
    var hasStartedLoading = media.hasAttribute('loaded') || media.playerProxy || media.querySelector('iframe, video');
    if (!initialHTML || !hasStartedLoading) return;

    media.querySelectorAll('iframe').forEach(function (iframe) {
      iframe.src = 'about:blank';
    });

    var wrapper = document.createElement('div');
    wrapper.innerHTML = initialHTML;
    var replacement = wrapper.firstElementChild;
    if (!replacement) return;

    replacement.__qqInitialHTML = initialHTML;
    media.replaceWith(replacement);
  }

  function moveInstagram(panel, direction) {
    var scroller = panel.querySelector('[data-qq-instagram-scroller]');
    var cards = Array.prototype.slice.call(panel.querySelectorAll('[data-qq-instagram-card]'));
    var state = instagramStates.get(panel);
    if (!scroller || !cards.length || !state) return;

    var nextIndex = Math.max(0, Math.min(cards.length - 1, state.current + direction));
    if (nextIndex === state.current) return;

    pauseInstagramCard(cards[state.current]);
    selectInstagramCard(panel, nextIndex);
    scrollInstagramTo(scroller, cards[nextIndex]);
    playInstagramPanel(panel);
  }

  function scrollInstagramTo(scroller, card) {
    scroller.scrollTo({
      left: card.offsetLeft - scroller.offsetLeft,
      behavior: 'smooth'
    });
  }

  function getNearestInstagramIndex(scroller, cards) {
    var scrollerRect = scroller.getBoundingClientRect();
    var nearestIndex = 0;
    var nearestDistance = Infinity;

    cards.forEach(function (card, index) {
      var distance = Math.abs(card.getBoundingClientRect().left - scrollerRect.left);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  function selectInstagramCard(panel, index) {
    var state = instagramStates.get(panel);
    var cards = Array.prototype.slice.call(panel.querySelectorAll('[data-qq-instagram-card]'));
    if (!cards.length) return;

    cards.forEach(function (card, cardIndex) {
      card.classList.toggle('is-selected', cardIndex === index);
    });

    if (state) state.current = index;
  }

  function playInstagramPanel(panel) {
    var state = instagramStates.get(panel);
    if (!state || panel.hidden || !state.inView) return;

    var cards = Array.prototype.slice.call(panel.querySelectorAll('[data-qq-instagram-card]'));
    cards.forEach(function (card, index) {
      if (index === state.current) {
        playInstagramCard(card);
      } else {
        pauseInstagramCard(card);
      }
    });
  }

  function pauseInstagramPanel(panel) {
    panel.querySelectorAll('[data-qq-instagram-card]').forEach(pauseInstagramCard);
  }

  function playInstagramCard(card) {
    var shell = card && card.querySelector('[data-qq-instagram-video-shell]');
    if (!shell) return;

    var video = shell.querySelector('video');
    if (!video) {
      var template = shell.querySelector('template');
      if (!template || !template.content || !template.content.firstElementChild) return;

      video = template.content.firstElementChild.cloneNode(true);
      video.muted = true;
      video.playsInline = true;
      shell.appendChild(video);
    }

    hideInstagramPoster(shell);
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseInstagramCard(card) {
    if (!card) return;
    card.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  function hideInstagramPoster(shell) {
    var poster = shell.querySelector('.qq-7-riders-video-reviews__instagram-poster, .qq-fs-placeholder');
    if (poster) poster.hidden = true;
  }

  function init(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-qq-video-tabs]')) {
      initTabs(target);
      initPosters(target);
      initInstagramSliders(target);
    }
    target.querySelectorAll('[data-qq-video-tabs]').forEach(function (root) {
      initTabs(root);
      initPosters(root);
      initInstagramSliders(root);
    });
  }

  window.QQVideoReviews = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
